
import { Fragment, useEffect, useState } from 'react';

import classes from './ProgressBar.module.scss';

const ProgressBar = (props) => {

    const [fillStep,setFillStep] = useState("0%");

    useEffect(() => {
        setFillStep(props.pbWidth);
    },[props.pbWidth]);

    
    return(
        <Fragment>            
            <div className={classes.pb_border}>
                <div className={classes.pb_fill} style={{"width" : `${fillStep}`}}></div>      
            </div>                                   
        </Fragment>
    );
};
export default ProgressBar;